<template>
  <div>
    <h1>This is the Mortgage Calculator page</h1>
  </div>
</template>

<script>
  export default {
    name: 'MortgageCalc'
  }
</script>

<style scoped>
</style>